import { render, staticRenderFns } from "./ISFDetailNotification.vue?vue&type=template&id=c79bd36c&"
import script from "./ISFDetailNotification.vue?vue&type=script&lang=js&"
export * from "./ISFDetailNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports